import { Box, Button, Circle, IconButton, Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { ReactComponent as ContextMenuIcon } from '../../svg/ContextMenu.svg'

export default function MobileLiveCourseCard({ name, start_time, trainer_name, duration, id }) {

    return (
        <Box
            d='flex'
            width='100%'
            bg='white'
            borderRadius='2xl'
            my='1rem'
            justifyContent='center'
            alignItems='flex-start'
            flexDirection='column'
            _hover={{ boxShadow: 'xl' }}
            px={['1rem', '1rem', '2rem']}
            pt={['1.5rem', '1.5rem', '2rem']}
        >
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='flex-start'
                width='100%'
                mb='1rem'
            >
                <Box
                    d='flex'
                    flexDir='column'
                    alignItems='flex-start'
                    justifyContent='center'
                >
                    <Text
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize='15px'
                        color='#798599'
                    >
                        Course
                    </Text>

                    <Text
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize='18px'
                        color='#333333'
                    >
                        {name}
                    </Text>
                </Box>

                <Menu>
                    <MenuButton
                        as={IconButton}
                        // mr='1rem'
                        border='2px solid rgba(0, 0, 0, 0.1)'
                        icon={<ContextMenuIcon />}
                        bg='white'
                        _hover={{ bg: "#f8f8f8" }}
                        _active={{ bg: "#f8f8f8" }}
                        size={['xs', 'sm', 'sm', 'lg']}
                        px='2'
                        py='1'
                    />
                    <MenuList style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize='15px' color='#00000099' minW='0' w='150px' position='relative' zIndex='10' >
                        <MenuItem>Delete</MenuItem>
                    </MenuList>
                </Menu>
            </Box>
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='flex-start'
                width='100%'
            >
                <Box
                    d='flex'
                    flexDir='column'
                    alignItems='flex-start'
                    justifyContent='center'
                    width={['60%', '60%', '50%']}
                >
                    <Text
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize={['12px', '14px', '15px']}
                        color='#798599'
                    >
                        Trainer Name
                    </Text>
                    <Box
                        d='flex'
                        height='100px'
                        width='100%'
                    >
                        <Text style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['16px', '16px', '18px', '18px']} color='#000000' >{trainer_name}</Text>
                    </Box>

                </Box>
                <Box
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='flex-end'
                    width={['40%', '40%', '50%']}
                    flexDirection='column'
                    height='100px'
                >
                    <Text
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize={['12px', '14px', '15px']}
                        color='#798599'
                    >
                        Duration (in Minutes)
                    </Text>

                    <Circle bg='#429fff' size='40px' border='1px solid white' color='white' style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize='15px'>
                        {duration}
                    </Circle>
                </Box>
            </Box>

            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='center'
                width='100%'
            >
                <Box
                    d='flex'
                    flexDir='column'
                    alignItems='flex-start'
                    justifyContent='center'
                    width={['60%', '60%', '50%']}
                >
                    <Text
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize={['12px', '14px', '15px']}
                        color='#798599'
                    >
                        Scheduled On
                    </Text>
                    <Box
                        d='flex'
                        height='100px'
                        width='100%'
                    >
                        <Text style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['16px', '16px', '18px', '18px']} color='#000000' >{start_time}</Text>
                    </Box>

                </Box>

                <Button
                    bgColor='#429fff'
                    color='white'
                    variant='outline'
                    p='0.75rem'
                    size={['sm', 'sm', 'md']}
                    fontWeight='700'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    borderRadius='lg'
                    fontSize={['11px', '13px', '15px']}
                    _hover={{ bg: "#3b8fe4" }}
                >
                    Start Session
                </Button>

            </Box>
        </Box>
    )
}